<template>
 <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Bestellijst" @hidden="$emit('close')">
    <div v-if="orderList === null" class="text-center p-50">
      <i class="fa fa-spin fa-5x fa-spinner"></i>
    </div>

    <div v-else>
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">
            Bestellijst: {{orderList.name}}
            <order-list-status-badge :orderList="orderList" class="ml-2" ref="orderListStatus" />
          </h3>
      </div>
      </div>

      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">
            Producten toevoegen
          </h3>
        </div>
        <div class="block-content">
        <div class="block-content p-0 row" style="margin-bottom: 10px">
          <input list="products" v-model="productName" ref="searchInput" v-on:input="getProducts" class="form-control" :placeholder="`Vul een product naam in`">
          <datalist id="products" >
            <option v-for="item in products" :key="item.id">{{item.name}}</option>
          </datalist>
        </div>
        </div>
          <button type="submit" class="btn btn-success btn-noborder" @click="addProductToOrderList">
            Toevoegen aan bestellijst<i class="fa fa-check"></i>
          </button>
        </div>

      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Producten</h3>
          <input class="form-control" v-model="toPredictSalesDate" @change="predictSalesForAllProducts" type="date" placeholder="Periode van" style="width: 200px">
        </div>
        <div class="block-content p-0">
          <table ref="table" class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th>Product</th>
                <th>Uitverkocht</th>
                <th>Voorspelde aantal</th>
                <th>Te bestellen aantal</th>
                <th>Acties</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="line in orderList.lines" :key="line.id">
                <td>{{line.product.name}}</td>
                <td>  <input class="form-control" @change="predictSalesPerProduct($event, line.product)" type="date" placeholder="Periode van"> </td>
                <td class="text-center font-w600" > {{ predictedProductSales[line.product.sku] }} </td>
                <td>
                  <input v-model="toOrderAmountProducts[line.product.sku]" type="number" class="form-control">
                </td>
                <td>
                  <button type="submit" class="btn btn-danger btn-noborder"  @click="deleteOrderListLine(line)">
                    Verwijderen
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
        <button type="submit" class="btn btn-success btn-noborder"  @click="updateOrderListLines(orderList.id)">
          Bestellen <i class="fa fa-check"></i>
        </button>
    </div>
  </b-modal>
</template>

<script>
import http from '../utils/http'
import OrderListStatusBadge from './OrderListStatusBadge.vue'
import Socket from '../barcode-scanner/socket'

export default {
  components: {
    OrderListStatusBadge
  },
  props: {
    orderListId: Number
  },
  data () {
    return {
      products: [],
      orderList: null,
      selectedDate: null,
      predictedProductSales: {},
      toOrderAmountProducts: {},
      toPredictSalesDate: null,
      productName: null
    }
  },
  methods: {
    loadOrderList () {
      const params = {
        include: 'lines,lines.product,lines.product.saleForecasts'
      }
      this.$api.getOrderList(this.orderListId, params)
        .then((result) => {
          this.orderList = result.data.data
          if (Object.keys(this.predictedProductSales).length === 0 || Object.keys(this.toOrderAmountProducts).length === 0) {
            this.fillArrays(this.orderList.lines)
          }
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze bestellijst konden we niet vinden. Probeer het opnieuw.', 'warning')
          this.$refs.modal.hide()
        })
    },
    getProducts () {
      const params = {}
      params[`filter[search]`] = this.productName

      http.get('/products', { params })
        .then((response) => {
          this.products = response.data.data
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het ophalen van de producten }. Probeer het opnieuw.`, 'error')
        })
    },
    addProductToOrderList () {
      if (this.products.length > 1) {
        this.$swal('Oeps! 😳', `Selecteer 1 product SVP. Probeer het opnieuw.`, 'error')
        return
      }
      if (this.predictedProductSales[this.products[0].sku] !== undefined) {
        this.$swal('Oeps! 😳', `Dit product bestaat al in de bestellijst. Probeer het opnieuw.`, 'error')
        return
      }
      const data = {
        order_list_id: this.orderListId,
        product_sku: this.products[0].sku
      }

      this.$http.post(`/order-list-line`, data)
      .then((response) => {
        this.$set(this.predictedProductSales, this.products[0].sku, 0)
        this.$set(this.toOrderAmountProducts, this.products[0].sku, 0)
        this.loadOrderList()
      })
      .catch(() => {
        this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het aanmaken van de bestellijst. Probeer het opnieuw.`, 'error')
      })
    },
    predictSalesPerProduct (period, product) {
      const date = new Date(period.target.value)

      const newSalesForecastArray = product.sale_forecasts.filter(function (saleForecast) {
        return new Date(saleForecast.ds) <= date
      })

      var predictedSales = 0

      newSalesForecastArray.forEach(element => {
        predictedSales += parseFloat(element.yhat)
      })

      this.$set(this.predictedProductSales, product.sku, Math.round(predictedSales))
      this.toOrderAmountProducts[product.sku] = Math.round(predictedSales)
    },
    predictSalesForAllProducts () {
      const date = new Date(this.toPredictSalesDate)

      for (const line of this.orderList.lines) {
        const newSalesForecastArray = line.product.sale_forecasts.filter(function (saleForecast) {
          return new Date(saleForecast.ds) <= date
        })

        var predictedSales = 0

        newSalesForecastArray.forEach(element => {
          predictedSales += parseFloat(element.yhat)
        })

        this.$set(this.predictedProductSales, line.product.sku, Math.round(predictedSales))
        this.toOrderAmountProducts[line.product.sku] = Math.round(predictedSales)
      }
    },
    fillArrays (lines) {
      lines.forEach(element => {
        this.$set(this.predictedProductSales, element.product.sku, 0)
        this.$set(this.toOrderAmountProducts, element.product.sku, 0)
      })
    },
    deleteOrderListLine (line) {
      http.delete(`/order-list-line/${line.id}`)
        .then((result) => {
          this.loadOrderList()
          delete this.predictedProductSales[line.product_sku]
          delete this.toOrderAmountProducts[line.product_sku]
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het verwijderen van de nieuwe order notificatie', 'warning')
        })
    },
    updateOrderListLines (id) {
      var validData = true
      for (const line of this.orderList.lines) {
        if (this.toOrderAmountProducts[line.product_sku] <= 0 || this.toOrderAmountProducts[line.product_sku] === '') {
          validData = false
          this.$swal('Ehmm...', 'Alle producten moeten een geldige waarde hebben. Probeer het opnieuw.', 'warning')
          break
        }
      }

      if (validData) {
        const data = {
          orderListArray: this.toOrderAmountProducts
        }
        http.patch(`/order-orderlist-lines/${id}`, data)
          .then((result) => {
            const statusData = {
              status: 'ordered'
            }
            http.patch(`/order-list/${id}`, statusData)
              .then((response) => {
                this.$swal('Hoera 😊', `De bestellijst is sucessvol besteld.`, 'success')
                this.$refs.modal.hide()
              })
              .catch(() => {
                this.$swal('Ehmm...', 'Er is iets misgegaan bij het bestellen van deze bestellijst. Probeer het opnieuw.', 'warning')
              })
          })
          .catch(() => {
            this.$swal('Ehmm...', 'Er is iets misgegaan bij het bestellen van deze bestellijst. Probeer het opnieuw.', 'warning')
          })
      }
    },
    handleMessage (event) {
      http.get(`/product-scanned/${event}`)
        .then((result) => {
          if (this.predictedProductSales[result.data.data.sku] !== undefined) {
            this.$swal('Oeps! 😳', `Dit product bestaat al in de bestellijst. Probeer het opnieuw.`, 'error')
            return
          }
          const data = {
            order_list_id: this.orderListId,
            product_sku: result.data.data.sku
          }

          this.$http.post(`/order-list-line`, data)
          .then((response) => {
            this.$set(this.predictedProductSales, result.data.data.sku, 0)
            this.$set(this.toOrderAmountProducts, result.data.data.sku, 0)
            this.loadOrderList()
          })
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze product konden we niet vinden. Probeer het opnieuw.', 'warning')
        })
    }
  },
  created () {
    this.loadOrderList()
    Socket.$on('message', this.handleMessage)
  },
  beforeDestroy () {
    Socket.$off('message', this.handleMessage)
  }
}
</script>

<style scoped>
a.disabled.block {
  cursor: not-allowed;
  opacity: 0.5;
}


</style>



// WEBPACK FOOTER //
// OrderListDetailModal.vue?045641e4